<div class="main-layout">
  <app-header></app-header>

  <main class="main-layout__content">
    <router-outlet></router-outlet>
  </main>

  <app-footer></app-footer>
</div>
